import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Card,
  Row,
  Col,
  DatePicker,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  SearchOutlined,
  UserOutlined,
} from "@ant-design/icons";
import moment from "moment";

import { useSelector, useDispatch } from "react-redux";
import { orderActions } from "../../store";
import STATUS from "../../consts/status";
import {
  renderOrderStatus,
  renderPaymentMethod,
  renderPaymentStatus,
  renderShippingMethod,
} from "../../utils/orderStatus";
import orderApi from "../../api/orderApi";
import { AiFillDelete } from "react-icons/ai";
import debounce from "lodash.debounce";

const Order = (props) => {
  const confirm = Modal.confirm;

  const { Option } = Select;
  const dispatch = useDispatch();
  const { lstOrder, totalCountOrder } = useSelector((x) => x.order);
  const dateFormat = "DD/MM/YYYY HH:mm:ss";

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const [btnDeleted, setBtnDeleted] = useState(false);
  const [listDeleted, setListDeleted] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [inputFilter, setFilter] = useState({
    orderCode: null,
    keyword: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    getOrders();
  }, [inputFilter]);

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, page: 1, orderCode: e.target.value });
  };

  const handleKeyWordSearch = (e) => {
    setFilter({ ...inputFilter, page: 1, keyword: e.target.value });
  };

  const getDataDebounce = useMemo(() => debounce(handleSearch, 300), []);
  const getKeywordDebounce = useMemo(
    () => debounce(handleKeyWordSearch, 300),
    []
  );

  const getOrders = () => {
    setLoading(true);
    dispatch(orderActions.getOrders(inputFilter)).then((res) => {
      setLoading(false);
    });
  };

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
      fixed: "left",
    },

    {
      title: "Mã đơn hàng",
      dataIndex: "orderCode",
      key: "orderCode",
      render: (text) => <b>#{text}</b>,
      width: "5%",
      fixed: "left",
    },
    {
      title: "Họ và tên",
      dataIndex: "customerName",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Số điện thoại",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      sorter: false,
      className: "text-center",
      render: (text, record) => (
        <a href={`tel:${record.phoneNumber}`}>{record.phoneNumber}</a>
      ),
    },
    {
      title: "Trạng thái đơn hàng",
      dataIndex: "status",
      key: "status",
      className: "text-center",
      render: (text) => <>{renderOrderStatus(text)}</>,

      width: "5%",
    },
    {
      title: "Phương thức thanh toán",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      className: "text-center",
      width: "5%",

      render: (text) => <>{renderPaymentMethod(text)}</>,
    },
    {
      title: "Trạng thái thanh toán",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      className: "text-center",
      width: "5%",

      render: (text) => <>{renderPaymentStatus(text)}</>,
    },
    {
      title: "Phương thức vận chuyển",
      dataIndex: "shippingMethod",
      key: "shippingMethod",
      className: "text-center",
      width: "5%",
      render: (text) => <>{renderShippingMethod(text)}</>,
    },
    // {
    //   title: "Trạng thái vận chuyển",
    //   dataIndex: "shippingStatus",
    //   key: "shippingStatus",
    //   className: "text-center",
    //   width: "5%",
    //   render: (text) => <>{renderShippingStatus(text)}</>,
    // },

    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      render: (createdAt) => <>{moment(createdAt).format(dateFormat)}</>,
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Link to={"/order/" + record.id}>
            <Button value="large" icon={<EyeOutlined />}>
              Xem
            </Button>
          </Link>
          <Button
            disabled={record.protected ? true : false}
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteOrder(record.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 50,
      fixed: "right",
    },
  ];

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }

    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      orderCode: inputFilter.orderCode,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted([]);
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      orderCode: record.orderCode,
    }),
  };

  const deleteOrder = (_id) => {
    const data = {
      ids: _id,
    };
    confirm({
      title: "Bạn có muốn xóa đơn hàng này không?",
      onOk() {
        orderApi
          .deleteOrder(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công  đơn hàng ");
              getOrders();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteOrders = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các đơn hàng này không?",
      onOk() {
        orderApi
          .deleteOrder(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công các đơn hàng ");
              getOrders();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6} className="ant-col-mt-10">
              <label> Mã đơn hàng</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                value={inputFilter.orderCode}
                placeholder="Nhập mã đơn hàng ..."
                onChange={getDataDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            <Col span={6} className="ant-col-mt-10">
              <label> Tìm kiếm</label>
              <br />
              <Input
                addonAfter={<UserOutlined />}
                defaultValue={inputFilter.keyword}
                placeholder="Nhập tài khoản, tên,email hoặc số điện thoại..."
                onChange={getKeywordDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            <Col span={6} className="ant-col-mt-10">
              <label className="">Phương thức thanh toán</label>
              <Select
                // value={inputFilter.role}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                // onChange={(e) => {
                //   setFilter({ ...inputFilter, role: e });
                // }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value="cod">Cod</Option>
                <Option value="banking">Banking</Option>
                <Option value="momo">Momo</Option>
                <Option value="vnpay">Vnpay</Option>
                {/* {lstRoles == null || lstRoles === "undefined" || lstRoles === []
                  ? []
                  : lstRoles.map((item, key) => (
                      <Option key={key} value={item.id}>
                        {item.name}
                      </Option>
                    ))} */}
              </Select>
            </Col>

            <Col span={6} className="ant-col-mt-10">
              <label className="">Trạng thái đơn hàng</label>
              <Select
                // value={inputFilter.role}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                // onChange={(e) => {
                //   setFilter({ ...inputFilter, role: e });
                // }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value={STATUS.ORDER_PENDING}>Chưa xác nhận</Option>
                <Option value={STATUS.ORDER_CONFIRM}>Đã xác nhận</Option>
                <Option value={STATUS.ORDER_CANCELED}>Đã Hủy</Option>
              </Select>
            </Col>

            <Col span={6} className="ant-col-mt-10">
              <label className="">Trạng thái thanh toán</label>
              <Select
                // value={inputFilter.role}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                // onChange={(e) => {
                //   setFilter({ ...inputFilter, role: e });
                // }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value={STATUS.PAYMENT_PAID}>Đã thanh toán</Option>
                <Option value={STATUS.PAYMENT_NOT_PAID}>Chưa thanh toán</Option>
              </Select>
            </Col>

            <Col span={6} className="ant-col-mt-10">
              <label className="">Trạng thái vận chuyển</label>
              <Select
                // value={inputFilter.role}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                // onChange={(e) => {
                //   setFilter({ ...inputFilter, role: e });
                // }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value={STATUS.SHIPPING_PENDING}>Chờ xác nhận</Option>
                <Option value={STATUS.SHIPPING_READY}>Chưa lấy hàng</Option>
                <Option value={STATUS.SHIPPING_PICKUP}>Đã lấy hàng</Option>
                <Option value={STATUS.SHIPPING_SHIPPING}>Đang giao hàng</Option>
                <Option value={STATUS.SHIPPING_DELIVERED}>Đã giao hàng</Option>
              </Select>
            </Col>

            <Col span={6} className="ant-col-mt-10">
              <label className="">Ngày bắt đầu</label>
              <br />
              <DatePicker
                className="ant-input input-picker-date"
                placeholder="Chọn ngày"
              />
            </Col>
            <Col span={6} className="ant-col-mt-10">
              <label className="">Ngày kết thúc</label>
              <br />
              <DatePicker
                className="ant-input input-picker-date"
                placeholder="Chọn ngày"
              />
            </Col>
          </Row>
        </Card>

        <br />
        <Space size={10}>
          <Link to="/order/add">
            <Button type="dashed" size="small">
              <EditOutlined /> &nbsp; Thêm đơn hàng
            </Button>
          </Link>
          {btnDeleted ? (
            <Button
              value="small"
              type="primary"
              icon={<AiFillDelete />}
              danger
              onClick={() => {
                deleteOrders();
              }}
            >
              &nbsp; Xóa các mục được chọn
            </Button>
          ) : null}
        </Space>
        <br />
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstOrder}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCountOrder,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>
      </div>
    </>
  );
};

export default Order;
